module.exports = __webpack_public_path__ + "static/img/no_history.00eab812.png";